import React, { useMemo, useState } from "react";
import { PageHero, PageBody, Lightbox } from "./_shared";
import { useBul } from "./BulLayout";

export default function Gallery() {
  const data = useBul();
  const photos = data.gallery || [];
  const [idx, setIdx] = useState(-1);

  const types = useMemo(() => {
    const set = new Set();
    photos.forEach((p) => p.gallery_type && set.add(p.gallery_type));
    return Array.from(set);
  }, [photos]);
  const [filter, setFilter] = useState("");
  const visible = filter ? photos.filter((p) => p.gallery_type === filter) : photos;

  const pillClass = (active) =>
    `text-[11px] uppercase tracking-[0.22em] font-semibold px-4 py-2 border transition-colors ${
      active
        ? "bg-[#0F0F10] text-white border-[#0F0F10]"
        : "bg-white text-[#0F0F10] border-[#D9D2C1] hover:border-[#FDBB30] hover:text-[#0F0F10]"
    }`;

  return (
    <div data-testid="bul-gallery">
      <PageHero eyebrow="Moments" title="Gallery" />
      <PageBody>
        {types.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-8">
            <button type="button" onClick={() => setFilter("")} className={pillClass(filter === "")}>All</button>
            {types.map((t) => (
              <button key={t} type="button" onClick={() => setFilter(t)} className={pillClass(filter === t)}>
                {t}
              </button>
            ))}
          </div>
        )}

        {visible.length === 0 ? (
          <div className="text-center bg-white p-16 border border-[#D9D2C1] text-[#726C61]">
            Photos will appear here once the institute uploads them.
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {visible.map((p, i) => (
              <button
                key={p.id}
                type="button"
                onClick={() => setIdx(i)}
                data-testid={`bul-gallery-photo-${p.id}`}
                className="aspect-square overflow-hidden bg-[#EDE7DA] group"
              >
                <img
                  src={p.image_url}
                  alt={p.caption || ""}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        )}
      </PageBody>
      {idx >= 0 && (
        <Lightbox photos={visible} idx={idx} onIdx={setIdx} onClose={() => setIdx(-1)} />
      )}
    </div>
  );
}
